import { useRestFetch } from '@shared/hooks/rest/fetch'

import Provider from './Provider'
import Content from './Content'
import AppBar from './appbar/AppBar'
import Drawer from './Drawer'
import { Outlet } from 'react-router-dom'

export default function Dashboard() {
    // prelaod
    useRestFetch({ key: ['offices'], endpoint: 'settings/offices/' })
    useRestFetch({ key: ['estimations'], endpoint: 'estimations/' })
    useRestFetch({ key: ['users'], endpoint: 'settings/users/' })

    return (
        <Provider>
            <Content>
                <AppBar />
                <Outlet />
            </Content>
            <Drawer />
        </Provider>
    )
}